import { render, staticRenderFns } from "./ZarinPalMemberCallback.vue?vue&type=template&id=463b73b8&scoped=true"
import script from "./ZarinPalMemberCallback.vue?vue&type=script&lang=js"
export * from "./ZarinPalMemberCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b73b8",
  null
  
)

export default component.exports